import { render, staticRenderFns } from "./PToast.vue?vue&type=template&id=67d29be4&"
import script from "./PToast.vue?vue&type=script&lang=js&"
export * from "./PToast.vue?vue&type=script&lang=js&"
import style0 from "./PToast.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports